<template>
  <div>
    <router-view style="width: calc(100vw - 17px);" class="nuxt" />
  </div>
</template>
<script>
import { removeToken } from "@/utils/auth";

export default {
  created() {
    const getScrollbarWidth = () => {
      const container = document.createElement('div');
      document.body.appendChild(container);
      container.style.overflow = 'scroll';
      const inner = document.createElement('div');
      container.appendChild(inner);
      const width = container.offsetWidth - inner.offsetWidth;
      document.body.removeChild(container);
      return width;
    };
    let check = window.localStorage.getItem('uid') || window.sessionStorage.getItem('uid')
    if (!check) {
      removeToken()
    }
    const scrollbarWidth = getScrollbarWidth();
    document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
  }
}
</script>
<style>
html {
  font-size: 12px;
  word-spacing: 1px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
  overflow: hidden;
  overflow-y: auto;
  background-color: #f5f7f9;
  display: flex;
  justify-content: center;
  align-items: center;
}

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
}

.button--green {
  display: inline-block;
  border-radius: 4px;
  border: 1px solid #3b8070;
  color: #3b8070;
  text-decoration: none;
  padding: 10px 30px;
}

.button--green:hover {
  color: #fff;
  background-color: #3b8070;
}

.button--grey {
  display: inline-block;
  border-radius: 4px;
  border: 1px solid #35495e;
  color: #35495e;
  text-decoration: none;
  padding: 10px 30px;
  margin-left: 15px;
}

.button--grey:hover {
  color: #fff;
  background-color: #35495e;
}
</style>